import http from 'http'
import server from 'src/utils/server'

export const getPaymentMethodConfigs = (paymentMethod) => {
  return http.get(server.url_to('payment_methods/' + paymentMethod))
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const loadParams = (paymentMethod) => {
  return http.get(server.url_to('payment_methods/load_params/' + paymentMethod))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getProcessors = () => {
  return http.get(server.url_to('processors/'))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getPaymentMethods = (payload) => {
  return http.get(server.url_to('processors/' + payload.processor + '/payment_methods?type=' + payload.type))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getNewPaymentMethods = (payload) => {
  return http.get(server.url_to('processors/' + payload.processor + '/configurable/payment_methods?type=' + payload.type))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getCustomFields = (payload) => {
  return http.get(server.url_to('processors/' + payload.processor + '/payment_methods/' + payload.paymentMethod + '/custom_fields'))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getCustomFieldsValues = (payload) => {
  return http.get(server.url_to('processors/' + payload.processor + '/payment_methods/' + payload.paymentMethod + '/custom_fields_values'))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const updatePaymentMethods = (payload) => {
  return http.post(server.url_to('processors/' + payload.processor + '/payment_methods/'), payload)
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const updatePaymentMethodConfigs = (params) => {
  return http.post(server.url_to('payment_methods/'), params)
  .then((response) => {
    return response
  })
  .catch(function (error) {
    return error.response
  })
}

export const findCep = (postalCode) => {
  return http.get(server.url_to('cep/' + postalCode))
  .then(function (response) {
    return response
  })
  .catch(function (error) {
    return error
  })
}

export const getBilletMethod = () => {
  return http.get(server.url_to('settings/7'))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getReprocessBilletMethod = () => {
  return http.get(server.url_to('settings/13'))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getCardMethod = () => {
  return http.get(server.url_to('settings/8'))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getReprocessCardMethod = () => {
  return http.get(server.url_to('settings/14'))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getTransferMethod = () => {
  return http.get(server.url_to('settings/15'))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const getSetting = (settingId) => {
  return http.get(server.url_to('settings/' + settingId))
    .then(function (response) {
      return response
    })
    .catch(function (error) {
      return error
    })
}

export const updateSetting = (params) => {
  return http.put(server.url_to('settings/' + params.id), params)
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const getGatewayFieldsValues = () => {
  return http.get(server.url_to('tax_invoice/sellers/get_config_gateway'))
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}

export const setupSeller = (params) => {
  return http.post(server.url_to('tax_invoice/sellers/setup'), params)
    .then((response) => {
      return response
    })
    .catch(function (error) {
      return error.response
    })
}



// WEBPACK FOOTER //
// ./src/app/pages/settings/services.js